'use client';

import { useSyncExternalStore } from 'react';
import { useDeviceHeader } from '../../providers/DeviceHeaderProvider/useDeviceHeader';

// TODO: move the breakpoint to a shared constants file, from where this hook and also the theme will use it
const DESKTOP_BREAKPOINT = 768;

const getClientSnapshot = (): boolean => {
  if (typeof window === 'undefined') return true;

  // Use matchMedia.matches - no layout reflow like innerWidth
  return window.matchMedia(`(min-width: ${DESKTOP_BREAKPOINT}px)`).matches;
};

const subscribe = (callback: () => void) => {
  if (typeof window === 'undefined') return () => {};

  const controller = new AbortController();

  const desktopQuery = window.matchMedia(`(min-width: ${DESKTOP_BREAKPOINT}px)`);
  desktopQuery.addEventListener('change', callback, { signal: controller.signal });

  return () => controller.abort();
};

/**
 * useMediaType syncs media type (desktop or not) between server and client
 * It uses DeviceHeaderProvider to get the device type from headers on the server
 * and matchMedia on the client
 * @returns boolean - true if desktop, false otherwise
 */
export const useMediaType = (): boolean => {
  const deviceFromHeaders = useDeviceHeader();

  // Server snapshot based on device type - returns true for desktop
  const getServerSnapshot = () => deviceFromHeaders === 'desktop';

  return useSyncExternalStore(subscribe, getClientSnapshot, getServerSnapshot);
};
